import { useAppSelector } from "@/store/app/hooks";
import type { RootState } from "@/store/app/storeTypes";

export const useActiveFileName = (): RootState["editor"]["activeSparx"] => {
  return useAppSelector((state) => state.editor.activeSparx);
};
